/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAccountInfos.defs.js'
export * as $defs from './getAccountInfos.defs.js'
